import React, { Fragment, useState, useEffect} from 'react';
import { Grid } from '@mui/material';
import ElementoElaboracionPlanDeMedios from './ElementoElaboracionPlanDeMedios';
import CardHeader from './CardHeader';
import FormularioSeleccionarMedio from './FormularioSeleccionarMedio';
import { obtenerRegistrosPersonalizado } from 'store/actions/customAction';
import { alertaPersonalizadaSwal } from 'servicios/AlertasPersonalizados';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import { useDispatch, useSelector } from 'react-redux';
import { nombreDeAcciones } from 'constantes';
import { eventoElectoral } from 'constantes/globalsStates';
import { functions } from 'constantes';
import ElementoElaboracionPlanDeMediosSegundaVuelta from './ElementoElaboracionPlanDeMediosSegundaVuelta';

let prespuestoDelPlanDeMediosAsignado = 0;
let eventoElectoralGlobal = 1;

const ElaboracionPlanDeMedios = () => {
  const dispatch = useDispatch();
  const {datosGenerales} = useSelector((state) => state);
  const [abrirFormulario, setAbrirFormulario] = useState(false);
  const [datosDelMedio, setDatosDelMedio] = useState({nivelCobertura: "", nombreMedio: "", tipoCandidatura: ""});
  const[cargandoSolicitud, setcargandoSolicitud] = useState(false);
  const [registrosDePlanDeMedios] = useState("registrosDePlanDeMedios");
  const [presupuestoPlanMedios, setPresupuestoPlanMedios] = useState([]);
  const [tarifasPlanMedios, setTarifasPlanMedios] = useState([]);

  useEffect(() => {
    obtenerPresupuestoPlanDeMedios()
  }, [])

  // useEffect(() => {
  //   obtenerTarifasPlanDeMedios()
  // }, [])

  const obtenerPresupuestoPlanDeMedios = async () => {

    setcargandoSolicitud(true);

    let respuesta = await dispatch(obtenerRegistrosPersonalizado({
        controller: registrosDePlanDeMedios,
        validateIfDataExists: true,
        nombreDelMetodo: `listar/presupuestoPlanDeMedios` ,
        stateInStore: datosGenerales.presupuestoPlanDeMedios,
        dispatchAction: nombreDeAcciones.SETEAR_PRESUPUESTO_PLAN_DE_MEDIOS,
    }));

    setcargandoSolicitud(false);

    if(respuesta?.error) return alertaPersonalizadaSwal( respuesta?.error?.message || 'No se pudó obtener las tarifas del plan de medios');

    let eventoIdLocal = respuesta?.data[0].evento_id === eventoElectoral ? eventoElectoral : 2;

    eventoElectoralGlobal = eventoIdLocal;

    const presupuestoDelEvento = respuesta?.data?.filter( (item) => item.evento_id === eventoIdLocal);
    const ordernarPresupuesto = functions.ordenarArreglo(presupuestoDelEvento, 'tipo_eleccion_id')
    prespuestoDelPlanDeMediosAsignado = ordernarPresupuesto;
    obtenerPresupuestoGastadoPlanDeMedios(ordernarPresupuesto)
  }

  const obtenerTarifasPlanDeMedios = async () => {

    setcargandoSolicitud(true);

    let respuesta = await dispatch(obtenerRegistrosPersonalizado({
        controller: registrosDePlanDeMedios,
        validateIfDataExists: true,
        nombreDelMetodo: `listar/tarifasPlanDeMedios` ,
        stateInStore: datosGenerales.tarifaPlanDeMedios,
        dispatchAction: nombreDeAcciones.SETEAR_TARIFAS_PLAN_DE_MEDIOS,
    }));

    setcargandoSolicitud(false);

    if(respuesta?.error) return alertaPersonalizadaSwal( respuesta?.error?.message || 'No se pudó obtener las tarifas del plan de medios');
    if(respuesta?.data?.length === 0) return alertaPersonalizadaSwal( "" || 'No existen las tarifas del plan de medios');

    const respuestaOrdenarda = functions.ordenarArreglo(respuesta?.data || [], 'idTipoMedioComunicacion')

    let arreglo = formatearTarifario(respuestaOrdenarda)
    const arregloATomar = []
    arregloATomar.push(arreglo[0]);
    setTarifasPlanMedios(arreglo)
  }

  const formatearTarifario = (tarifasEncontradas) => {
    let arreglo = [];

    tarifasEncontradas.forEach( ({tarifa_electoral, tipoDeMedioDeComunicacion, nivelDeCobertura, idTipoMedioComunicacion, idNivelDeCobertura}) => {
      const existeTarifa = arreglo.some((item) => Number(item.id) === Number(idTipoMedioComunicacion) )
      if(existeTarifa) {
            arreglo = arreglo.map( item =>
            ({...item,
                datosDelMedio: {
                    ...item.datosDelMedio,
                    nivelCobertura: item.datosDelMedio.nivelCobertura.some( item2 => item2.id === nivelDeCobertura.id ) ? item.datosDelMedio.nivelCobertura : [...item.datosDelMedio.nivelCobertura, {...nivelDeCobertura, name: `COBERTURA ${nivelDeCobertura.descripcion || ""}`, tarifa_electoral}]
                }
            }))
        } else {
            arreglo.push({
                id: idTipoMedioComunicacion,
                nombreDelMedio: tipoDeMedioDeComunicacion?.descripcion || "",
                datosDelMedio: {
                    nivelCobertura: [{...nivelDeCobertura, name: `COBERTURA ${nivelDeCobertura.descripcion || ""}`, tarifa_electoral}],
                    nombreDelMedio: tipoDeMedioDeComunicacion?.descripcion || "",
                    tarifa_electoral,
                }
            })
        }
    })

    return arreglo;
  }

  const obtenerPresupuestoGastadoPlanDeMedios = async (ordernarPresupuesto) => {

    setcargandoSolicitud(true);

    let respuesta = await dispatch(obtenerRegistrosPersonalizado({
        controller: registrosDePlanDeMedios,
        saveInStore: false,
        nombreDelMetodo: `listar/cantidadDeDineroGastado` ,
    }));

    setcargandoSolicitud(false);

    if(respuesta?.error) return alertaPersonalizadaSwal( respuesta?.error?.message || 'No se pudó obtener el presupuesto gastado del plan de medios');


    const presupuestoSinUsar = ordernarPresupuesto?.map((item) => {
      const elemento = respuesta?.data?.filter( ({idTipoEleccion}) => idTipoEleccion === item.tipo_eleccion_id);
      if(elemento.length > 0) return ({...item, montoTotal: new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'GTM' }).format( item.montoTotal - elemento[0].sumaTotalCosto || 0) })
      else return item
    })

    setPresupuestoPlanMedios(presupuestoSinUsar);
    obtenerTarifasPlanDeMedios()

  }


  const asignarPlanDeMedio= (medio, nivelCobertura, idTipoMedioDeComunicacion) => {
    setDatosDelMedio({...medio, nivelCobertura, idTipoMedioDeComunicacion})
    setAbrirFormulario(true);
  }

  const cerrarFormulario= () => {
    obtenerPresupuestoGastadoPlanDeMedios(prespuestoDelPlanDeMediosAsignado)
    setAbrirFormulario(false)
  };

  return (
    <Fragment>
        {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }

        <CardHeader presupuestoPlanMedios={presupuestoPlanMedios} eventoElectoralGlobal={eventoElectoralGlobal} />

        <div className="height600" style={{marginTop: 70, paddingBottom: 30}}>

        <Grid container justifyContent={"space-around"} alignItems={"center"} spacing={2} style={{marginTop: '-60px'}} >
          {eventoElectoralGlobal === eventoElectoral ?
            tarifasPlanMedios?.map( ({id, nombreDelMedio, datosDelMedio}) => (
              <ElementoElaboracionPlanDeMedios key={id} idTipoMedioDeComunicacion={id} nombreDelMedio={nombreDelMedio} datosDelMedio={datosDelMedio} asignarPlanDeMedio={asignarPlanDeMedio} />
            ))
          : tarifasPlanMedios?.map( ({id, nombreDelMedio, datosDelMedio}) => (
            <ElementoElaboracionPlanDeMediosSegundaVuelta key={id} idTipoMedioDeComunicacion={id} nombreDelMedio={nombreDelMedio} datosDelMedio={datosDelMedio} asignarPlanDeMedio={asignarPlanDeMedio} />
          ))}
          </Grid>
        </div>

        {abrirFormulario && (
            <FormularioSeleccionarMedio
                openFullScreenDialog={abrirFormulario}
                handleClose={cerrarFormulario}
                title={"Formulario para seleccionar corporación"}
                datosDelMedio={datosDelMedio}
            />
        )}
    </Fragment>
  );
}

export default ElaboracionPlanDeMedios;